import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';
import Spinner from '@tds/core-spinner';

import { EditOverlay } from '../../css';
import request from '../../../../../../../../utils/request';

const Overlay = ({ id, name, fetchData, setInDeleteMode }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const resetState = () => {
    setIsDeleting(false);
    setInDeleteMode(false);
    fetchData();
  };

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      const result = await request.delete(`/dealerships/${id}`);

      if (result && result.status === 200) {
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  return (
    <EditOverlay>
      <Spinner label="deleting..." spinning={isDeleting}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%'
          }}
        >
          <p style={{ fontWeight: '600', textAlign: 'center' }}>
            {' '}
            Are you sure you want to delete {name}?
          </p>
          <Button type="button" onClick={handleDelete}>
            Confirm
          </Button>
          <Button
            variant="secondary"
            type="button"
            onClick={() => setInDeleteMode(false)}
          >
            Cancel
          </Button>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  setInDeleteMode: PropTypes.func.isRequired
};

export default Overlay;
